<!--header-right-->
<template>
  <div class="home-auth-list" >
    <hs-section-header
        :title="$t('TravelApplication')"
        :showBtnText="list.length > 1"
        v-model="showAuthList"
    />
    <div class="list">
      <home-auth-list-item
          v-for="(item, index) in oaList"
          :details="item"
          :key="index"
          @gotoDetails="_gotoOaDetails(item)"
          @gotoBooking="_gotoBook(item)"
      />
      <div v-if="hasPower('我的:授权码订单') && list.length > 3 && showAuthList" class="more" @click="_lookMoreOa">{{$t('SeeAll')}}</div>
    </div>

    <hs-teleport to="body">
      <select-business-book ref="RefsSelectBusinessBook" :type="'new-style'" :list="oaBusinessList" @select="_goToOaBooking" />
    </hs-teleport>
  </div>
</template>
<script type="text/ecmascript-6">
import HsSectionHeader from "@/base/hs-tableview/hs-section-header.vue";
import HomeAuthListItem from "@/pages/home/home/home-auth-list-item.vue";
import HsTeleport from "@/base/hs-teleport/hs-teleport.vue";
import SelectBusinessBook from "@/pages/home/select-business-book.vue";
import {getRoutePath, hotelRoutePush, planeRoutePush, trainRoutePush} from "@/common/utility/utils";
const MORE_LIMIT = 3
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      showAuthList: false,
      oaBusinessList: [],
    }
  },
  computed: {
    oaList() {
      let oaList = this.list || []
      if (this.showAuthList) {
        oaList = oaList.slice(0, 3)
      } else {
        oaList = oaList.slice(0, 1)
      }
      return oaList
    }
  },
  methods: {
    _gotoOaDetails(item) {
      let {Code, CreateSource} = item
      // 内部出差申请单 = 1,
      // 外部出差申请单 = 2
      this.$router.push({
        path: '/personal/authOrderDetails',
        query: {
          Code: Code,
          back: 1,
          fixedBackPath: '/home'
        }
      })
    },

    /** 每个业务对象 */
    _initBusItem(Code, OrderBusinessType, title) {
      return {
        Code: Code,
        OrderBusinessType: OrderBusinessType,
        title: title,
      }
    },

    // 跳转业务下单
    _gotoBook(item) {
      this.oaBusinessList = []
      let flightItem = null
      let InterflightItem = null
      let count = 0
      if (item.FlightInfo && item.FlightInfo.IsDisplayBookButton) {
        flightItem = this._initBusItem(item.Code, 1, this.$t('DomesticFlights'))
        count++
      }
      if (item.IntlFlightInfo && item.IntlFlightInfo.IsDisplayBookButton) {
        InterflightItem = this._initBusItem(item.Code, 6, this.$t('IntlFlights'))
        count++
      }

      if (flightItem && InterflightItem) {
        this.oaBusinessList.push({
          Code: item.Code,
          OrderBusinessType: 1,
          title: this.$t('FlightTicket'),
          children: [flightItem, InterflightItem]
        })
      } else if (flightItem || InterflightItem) {
        this.oaBusinessList.push(flightItem || InterflightItem)
      }

      if (item.IntlFlightInfo && item.IntlFlightInfo.IsDisplayEnquiryButton) {
        this.oaBusinessList.push(this._initBusItem(item.Code, 17, this.$t('IntlFlightEnquiry')))
        count++
      }

      let hotelItem = null
      let interHotelItem = null
      if (item.HotelInfo && item.HotelInfo.IsDisplayBookButton) {
        hotelItem = this._initBusItem(item.Code, 2, this.$t('DomesticHotel'))
        count++
      }
      if (item.IntlHotelInfo && item.IntlHotelInfo.IsDisplayBookButton) {
        interHotelItem = this._initBusItem(item.Code, 11, this.$t('IntlHotel'))
        count++
      }

      if (hotelItem && interHotelItem) {
        this.oaBusinessList.push({
          Code: item.Code,
          OrderBusinessType: 2,
          title: this.$t('Hotel'),
          children: [hotelItem, interHotelItem]
        })
      } else if (hotelItem || interHotelItem) {
        this.oaBusinessList.push(hotelItem || interHotelItem)
      }

      if (item.TrainInfo && item.TrainInfo.IsDisplayBookButton) {
        this.oaBusinessList.push(this._initBusItem(item.Code, 10, this.$t('TrainTicket')))
        count++
      }
      if (item.CarInfo && item.CarInfo.IsDisplayBookButton) {
        this.oaBusinessList.push({
          ...this._initBusItem(item.Code, 14, this.$t('Car')),
          ApplyType: item.ApplicationFormType
        })
        count++
      }
      if (count === 1) {
        this._goToOaBooking(this.oaBusinessList[0])
      } else if (count > 1) {
        this.$refs.RefsSelectBusinessBook && this.$refs.RefsSelectBusinessBook.open()
      }
    },
    // 申请单跳转业务下单
    _goToOaBooking(item) {
      let OrderBusinessType = item.OrderBusinessType
      let Code = item.Code
      if (OrderBusinessType === 1) { // 国内机票
        this._gotoFlightBooking(Code)
      } else if (OrderBusinessType === 6) { // 国际机票
        this._gotoIntlFlightBooking(Code)
      } else if (OrderBusinessType === 2) { // 国内酒店
        this._gotoHotelBooking(Code)
      } else if (OrderBusinessType === 11) { // 海外酒店
        this._gotoIntlHotelBooking(Code)
      } else if (OrderBusinessType === 10) { // 火车票
        this._gotoTrainBooking(Code)
      } else if (OrderBusinessType === 14) { // 用车
        this._gotoCarBooking(Code, item.ApplyType)
      } else if (OrderBusinessType === 17) { // 国际机票需求单
        this._gotoInquirySheetBooking(Code)
      }
    },

    /** 预订 */
    _gotoFlightBooking(Code) {
      if (!this.hasPower('因公:机票')) {
        this._showTips()
        return false
      }
      planeRoutePush({
        path: '/planeTicket/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 1,
          back: 1
        }
      })
    },

    _gotoIntlFlightBooking(Code) {
      if (!this.hasPower('因公:机票')) {
        this._showTips()
        return false
      }
      planeRoutePush({
        path: '/planeTicket/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 6,
          back: 1
        }
      })
    },

    _gotoHotelBooking(Code) {
      if (!this.hasPower('因公:酒店')) {
        this._showTips()
        return false
      }

      hotelRoutePush(getRoutePath({
        path: '/hotel/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 2,
          fixedBackPath: 'home'
        }
      }))
    },

    _gotoIntlHotelBooking(Code) {
      if (!this.hasPower('因公:酒店')) {
        this._showTips()
        return false
      }
      hotelRoutePush(getRoutePath({
        path: '/hotel/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 11,
          fixedBackPath: 'home'
        }
      }))
    },

    _gotoTrainBooking(Code) {
      if (!this.hasPower('因公:火车票')) {
        this._showTips()
        return false
      }
      trainRoutePush({
        path: '/train/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          fixedBackPath: '/home',
          back: 1,
        }
      })
    },

    _gotoCarBooking(Code, ApplyType) {
      if (!this.hasPower('因公:用车')) {
        this._showTips()
        return false
      }
      this.$router.push({
        path: '/car/query',
        query: {
          ApplyType: ApplyType,
          TravelType: 0,
          AuthorizationCode: Code,
          fixedBackPath: 'home'
        }
      })
    },

    _gotoInquirySheetBooking(Code) {
      this.$router.push({
        path: '/intlPlaneTicket/inquirySheet',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          fixedBackPath: '/home',
        }
      })
    },

    /** 查看更多oa申请单 */
    _lookMoreOa() {
      this.$router.push({
        path: '/personal/authOrderList',
        query: {
          fixedBackPath: '/home',
          ClientStatus: 1
        }
      })
    },

    _showTips(str) {
      this.$toast(str || this.$t('NoPermissions'))
    },
  },
  components: {
    HsSectionHeader,
    HomeAuthListItem,
    HsTeleport,
    SelectBusinessBook
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.home-auth-list
  width 100%
  border-radius 12px
  overflow hidden
  margin-bottom 12px
  border 0.5px solid $color_orange_100
  >.list
    background-color $color_black_0
    >.more
      @extend .flex-center
      @extend .hs-font-subtitle-middle
      width 100%
      min-height 44px
      color $color_black_100
      border-top 1px solid $color_black_30
</style>
